module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Desktop.4af0c409.jpg";